import { Instance, types } from 'mobx-state-tree';

import ClientProgramGroupProgram from './ClientProgramGroupProgram';

const ClientProgramGroup = types.model('ClientProgramGroup', {
	assistant_teacher_id: types.maybeNull(types.number),
	group_id: types.maybeNull(types.number),
	id: types.identifierNumber,
	main_teacher_id: types.maybe(types.number),
	name: types.optional(types.string, ''),
	partner_teacher_id: types.maybeNull(types.number),
	program: types.maybeNull(ClientProgramGroupProgram),
});

export default ClientProgramGroup;

export interface ClientProgramGroupModel extends Instance<typeof ClientProgramGroup> {}
